enum ClipEndpoints {
    GET = '/assets/clips',
    GET_BY_ID = '/assets/clips/{id}',
    CREATE = '/assets/clips/{id}/clips',
    OVERWRITE = '/assets/clips/{id}',
    GET_CLIPS_BY_ID = '/assets/clips/{id}/clips',
}

export { ClipEndpoints };
